module.exports = __webpack_public_path__ + "static/media/kingspan-logo.0880b6c7.svg";